module.exports = __webpack_public_path__ + "img/syukyaku-landing-pa001.5321f522.png";